/* DYNAMO · Varianten-abhängige Inhalte (Set-Inhalt im Kaufbereich, aktive Spalte der Lieferumfang-Tabelle).
   Liest die gewählten Werte aus dem Horizon-Variantenwähler. Als Modul geladen, läuft nur einmal je Seite. */
const dyNorm = (s) => (s || '').toString().replace(/\s+/g, ' ').trim().toLowerCase();

function dyGewaehlt() {
  const werte = [];
  document
    .querySelectorAll('variant-picker fieldset input:checked, variant-picker select')
    .forEach((el) => werte.push(dyNorm(el.value)));
  return werte;
}

function dyAnwenden() {
  const werte = dyGewaehlt();
  if (!werte.length) return;
  document.querySelectorAll('[data-dy-set]').forEach((kasten) => {
    const panels = kasten.querySelectorAll('[data-dy-variante]');
    let treffer = null;
    panels.forEach((p) => {
      if (werte.includes(dyNorm(p.dataset.dyVariante))) treffer = p;
    });
    if (!treffer) return;
    panels.forEach((p) => {
      p.hidden = p !== treffer;
    });
  });
  document.querySelectorAll('[data-dy-spalte]').forEach((zelle) => {
    zelle.classList.toggle('ist-aktiv', werte.includes(dyNorm(zelle.dataset.dySpalte)));
  });
}

document.addEventListener('change', (e) => {
  const ziel = e.target;
  if (ziel instanceof Element && ziel.closest('variant-picker')) requestAnimationFrame(dyAnwenden);
});
dyAnwenden();
